import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Hats } from '../../@resources/hats';
import { Hat } from '../canvas/participants/Hat';
import { Avatar } from '../common/Avatar';
import { useResolve } from '../Container';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { ProfileModel } from '../ProfileModel';

export const HatDevPage = () => {
    const me = useResolve(ProfileModel);
    return <Flexer inset="10" flex="row" center wrap="wrap" gap="4">
        {Object.keys(Hats).map(type =>
            <Flexer key={type} relative width="5" height="5">
                <Hat key={type} type={type}>
                    <Avatar.ForUser size="5" user={me} border="none" />
                </Hat>
            </Flexer>
        )}
    </Flexer>;

};
